import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7313 2.26893C21.239 1.77675 20.5714 1.50024 19.8753 1.50024C19.1791 1.50024 18.5115 1.77675 18.0193 2.26893L16.8623 3.42593L20.5743 7.13793L21.7313 5.98093C22.2234 5.48866 22.4999 4.82105 22.4999 4.12493C22.4999 3.42882 22.2234 2.7612 21.7313 2.26893ZM19.5133 8.19894L15.8013 4.48693L3.65125 16.6369C3.03411 17.2538 2.58043 18.0147 2.33125 18.8509L1.53125 21.5359C1.49263 21.6655 1.48975 21.8031 1.52292 21.9342C1.55608 22.0652 1.62407 22.1849 1.71967 22.2805C1.81527 22.3761 1.93494 22.4441 2.06601 22.4773C2.19709 22.5104 2.33469 22.5076 2.46425 22.4689L5.14925 21.6689C5.98548 21.4198 6.74642 20.9661 7.36325 20.3489L19.5133 8.19894Z"
        fill={colorValue}
      />
    </svg>
  );
};
